<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div class="main">
  <div class="modal-header">
    <div class="titleCont">
      <h3 class="modal-title"></h3>
      <h5>{{'ORDER_LOCATIONS_USING_DRAG_DROP' | translate}}</h5>
    </div>
    <br/>
    <button type="button" class="close" aria-label="Close" matDialogClose>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>


  <div *ngIf="readyToRender" class="mainCont">
    <mat-accordion multi="true" displayMode="flat">
      <div cdkDropList #main id="_main"
           [cdkDropListConnectedTo]="getConnectedList()"
           [cdkDropListData]="locations"
           (cdkDropListDropped)="dropGroup($event)">


        <div class="main-list-container"
             *ngFor="let location of locations"
             cdkDrag
             [cdkDragData]="location"
             [cdkDragDisabled]="location.type === 'inBetween'"
             (cdkDragStarted)="isDragging = true"
             (cdkDragEnded)="isDragging = false">
          <mat-expansion-panel
            [expanded]="location.type === 'inBetween'"
            [disabled]="location.type === 'inBetween'"
            [ngClass]="location.type === 'inBetween' ? 'inBetween' : 'locationsGroup'">
            <mat-expansion-panel-header>
              <mat-chip-list>
                <mat-chip style=""><img *ngIf="location.type"
                                        [src]="'../../../assets/images/chart/' + getImg(location.type) +'.png'"
                                        class="list-picto-device"/>{{location.name}}</mat-chip>
              </mat-chip-list>
            </mat-expansion-panel-header>
            <div cdkDropList class="parent-list"
                 [ngClass]="{'withMinHeight': isDragging}"
                 [id]="location.name"
                 [cdkDropListData]="location.child"
                 (cdkDropListDropped)="dropItem($event, location)"
                 [cdkDropListConnectedTo]="getConnectedList()">
              <div class="children-list"
                   *ngFor="let locationChild of location.child"
                   cdkDrag [cdkDragData]="locationChild"
                   (cdkDragStarted)="isDragging = true"
                   (cdkDragEnded)="isDragging = false">
                <img *ngIf="locationChild.type"
                     [src]="'../../../assets/images/chart/' + getImg(locationChild.type) +'.png'"
                     class="list-picto-device"/>
                {{locationChild.name}}
              </div>
            </div>
          </mat-expansion-panel>
          <div class="tooltip-wrapper"
               [ngbTooltip]="((!location.child || (location.child?.length === 0)) ? 'DELETE_DD_GROUP_TT': 'CANT_DELETE_DD_GROUP_TT') | translate ">
            <button class="delete-button" [disabled]="location.child && (location.child?.length !== 0) "
                    *ngIf="!location.type">
              <fa-icon (click)="deleteGroup(location)" [icon]="faTimes"
                       [ngClass]="{inactive: location.child && location.child?.length > 0, isBeingRemoved: location.isBeingRemoved}"
              >
              </fa-icon>
            </button>
          </div>
        </div>

      </div>

    </mat-accordion>

    <div class="add-group-section">
      <div class="add-group-container">
        <div class="add-group-header">{{'ADD_GROUP_DD_TITLE' | translate}}</div>
        <div class="add-group-form">
          <input #name class="form-control" type="text" [placeholder]="'SELECT_GROUP_NAME' | translate">
          <button class="btn btn-group" (click)="createGroup(name.value); name.value = null"
                  [disabled]="!name.value">{{"ADD_GROUP_DD" | translate}}</button>
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button mat-button id="close-button" class="btn btn-group" (click)="matDialog.closeAll()" style="position: relative">{{'CLOSE' | translate}}</button>
  </div>

</div>

